<template>
  <section id="overview" class="section">
    <div class="section__content section__content--overview">
      <div class="area-top">
        <div class="wrap">
          <div data-aos="fade-up">
            <div
              class="section__title-img"
              data-aos="fade-up"
              data-aos-delay="800"
            ></div>
            <div class="section__title">
              <span class="span-1"
                >把握得分致勝關鍵
                <div class="shrink">？</div></span
              ><br />
              <span class="span-2 section__span--bold"
                >主動找出潛力股
                <div class="shrink comma">，</div></span
              ><br class="inactive" />
              <span class="span-3 section__span--bold"
                >讓投資跟上成長動能
                <div class="shrink">！</div></span
              >
            </div>
          </div>

          <div class="table-box table-box-1" data-aos="fade-up">
            <div class="table-box__item">
              <div class="table-box__title">績效表現</div>
              <div class="sub-title sub-title-1 blue">
                <p>亮眼佳績</p>
                <p>每年含息總報酬</p>
              </div>
              <div class="chart">
                <img src="../assets/images/s3_chart-1.png" alt="" />
              </div>
              <div>
                <div class="awards"></div>
                <!-- <a
                  href="#"
                  class="awards-btn common-btn"
                  @click.prevent="openAwards"
                  >查看歷年獲獎紀錄</a
                > -->
              </div>

              <div class="secure-text">
                資料來源：Lipper、商周Smart智富、中國信託投信整理，淨值走勢區間是自基金於2016/06/08成立以來至2025/05/31。*本基金I/A(USD)、R/A(USD)級別成立日期均為2016/06/08。欲查詢完整得獎紀錄，請詳見https://www.ctbcinvestments.com/About/OutsidePartner。<span class="highlight"
                  >本基金非為保本型或保證型投資策略，非定存之替代品，亦不保證收益分配[如有]之金額與本金之全額返還，最大可能損失則為全部投資金額。以上指數為含息報酬指數，僅供參考用途，其歷史績效不應被視為現在或未來表現及績效的保證，亦不代表基金現在或未來之報酬率。
                </span>
              </div>
            </div>

            <div class="table-box__item">
              <div class="sub-title sub-title-2 blue">
                <p>美國前10大持股</p>
                <p>投進標的好球帶</p>
              </div>
              <div class="chart">
                <img src="../assets/images/s3_chart-2.png" alt="" />
              </div>
              <a
                href="#"
                class="more-btn common-btn"
                @click.prevent="openCompany"
                >查看更多公司細節</a
              >
              <div class="secure-text">
                資料時間：2025/08/31。資料來源：法盛投資管理，中國信託投信整理。
                <span class="highlight"
                  >若內容涉及個股、類股或產業，僅為參考舉例，不代表個股、類股或產業推薦，且不為未來投資獲利之保證，亦不一定為基金未來之持股。投資人申購本基金係持有基金受益憑證，而非本文提及之投資資產或標的。</span
                >
              </div>
            </div>
          </div>

          <div class="table-box table-box-2 table-box--border">
            <div class="table-box__item">
              <div class="table-box__title">投資組合</div>
              <div class="sub-title sub-title-1 blue">
                <p>產業配置</p>
                <p>獨創獲利引擎</p>
              </div>
              <div class="chart">
                <img src="../assets/images/s3_chart-3.png" alt="" />
              </div>
            </div>

            <div class="table-box__item">
              <div class="sub-title sub-title-2 blue">
                <p>規模分布</p>
                <p>瞄準市值區間500億美元規模</p>
              </div>
              <div class="chart">
                <img src="../assets/images/s3_chart-4.png" alt="" />
              </div>
              <div class="secure-text">
                資料來源：法盛投資管理，中國信託投信整理。為2025/08/31資料；<span
                  class="highlight"
                  >若內容涉及個股、類股或產業，僅為參考舉例，不代表個股、類股或產業推薦，且不為未來投資獲利之保證，亦不一定為投組未來之持股。投資人申購本基金係持有基金受益憑證，而非本文提及之投資資產或標的。
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="area-bottom">
        <div class="wrap" data-aos="fade-up">
          <div class="area-bottom__content">
            <div class="area-bottom__title">基金資訊</div>
            <div class="area-bottom__sub-title">
              法盛盧米斯賽勒斯<br class="inactive" />美國成長股票基金
            </div>
            <div class="item">
              <div class="list" v-for="list in lists" :key="list.title">
                <p class="list__title">{{ list.title }}</p>
                <p class="list__sub-title" v-html="list.subTitle"></p>
              </div>
            </div>
            <div class="secure-text">
              資料來源：法盛投資管理、Bloomberg，2025/08/31。<span
                class="highlight"
                >*註：依中國信託投信之風險報酬等級表達原則，其中RR1~RR2為保守型，RR3~RR4為穩健型，RR5為積極型。本基金為股票型基金，主要投資於美國與全球成熟市場之股票。參酌中華民國證券投資信託暨顧問商業同業公會所制定之基金風險報酬等級分類標準，基金風險報酬等級訂為RR4(風險報酬等級係計算過去5年基金淨值波動度標準差，以標準差區間予以分類年基金淨值波動度標準差，以標準差區間予以分類等級等級)。
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useMainStore } from '@/store/main';

export default {
  name: 'Overview',
  props: {},
  data: () => {
    return {
      lists: [
        { title: '註冊地', subTitle: '盧森堡' },
        { title: '基金經理人', subTitle: 'Aziz Hamzao-<br />gullari' },
        { title: '成立日期', subTitle: '2016/06/08' },
        { title: '基金規模', subTitle: '5,884 百萬美元*' },
        { title: '基準指數', subTitle: '標準普爾500指數<br />(總報酬)' },
        { title: '晨星分類', subTitle: '美國大型成長股票' },
        { title: '風險級別**', subTitle: 'RR4' },
        { title: '持有標的數', subTitle: '36' },
      ],
    };
  },
  computed: {
    // ...mapState([])
  },
  methods: {
    ...mapActions(useMainStore, ['openPopup']),
    openAwards() {
      console.log('open awards');
      this.openPopup('popup-awards');
    },
    openCompany() {
      this.openPopup('popup-company');
    },
  },
  mounted() {},
  components: {},
};
</script>

<style lang="scss">
$assets: '~@/assets/images/overview/';

#overview {
  .section__content {
    .wrap {
      zoom: 0.8;
      @include tablet {
        zoom: 1;
      }
    }

    .area-top {
      width: 100%;
      max-width: 1920px;
      background-image: url('../assets/images/s3-1_bg.jpg');
      background-repeat: repeat-y;
      background-size: 1920px 4354px;
      background-position: center top;
      position: relative;
      z-index: 2;
      padding: calc(130px * 0.8) 0 calc(245px * 0.8) 0;
      @include tabletX {
        background-size: vwX(1920) vwX(4354);
        padding: calc(vwX(130) * 0.8) 0 calc(vwX(245) * 0.8) 0;
      }
      @include tablet {
        width: 100%;
        // height: vwM(6764);
        background-image: url('../assets/images/s3-1_bg_m.jpg');
        background-size: cover;
        padding: vwM(186) 0 vwM(260) 0;
      }
    }
    .section__title-img {
      width: 608px;
      height: 620px;
      background-image: url('../assets/images/s3_titile_img.png');
      background-size: 608px 620px;
      top: -320px;
      left: 804px;
      z-index: 2;
      @include tabletX {
        width: vwX(608);
        height: vwX(620);
        background-size: vwX(608) vwX(620);
        top: vwX(-320);
        left: vwX(804);
      }
      @include tablet {
        width: vwM(682);
        height: vwM(770);
        background-size: vwM(682) vwM(770);
        top: vwM(-434);
        left: vwM(320);
      }
    }

    .section__title {
      .shrink {
        display: inline-block;
        margin: 0 -22px;
        @include tabletX {
          margin: 0 vwX(-22);
        }
        @include tablet {
          margin: 0 vwX(-30);
        }
      }
      .span-2 {
        padding-right: 22px;
        @include tabletX {
          padding-right: vwX(22);
        }
        @include tablet {
          padding-left: vwM(58);
          padding-right: vwX(58);
        }
        .comma {
          @include tablet {
            display: none;
          }
        }
      }
      .span-3 {
        padding-left: 0;
        @include tablet {
          padding-left: vwM(58);
        }
      }
    }
    .table-box-1 {
      margin-top: 16px;
      @include tabletX {
        margin-top: vwX(16);
      }
      @include tablet {
        margin-top: vwM(25);
      }

      .table-box__item:nth-child(1) {
        .sub-title {
          margin-bottom: 45px;
          @include tabletX {
            margin-bottom: vwX(45);
          }
          @include tablet {
            margin-bottom: vwM(120);
          }
        }
        .chart img {
          width: 1099px;
          // height: 414px;
          @include tabletX {
            width: vwX(1099);
            // height: vwX(414);
          }
          @include tablet {
            // width: vwM(1588);
            // height: vwM(598);
            width: vwM(885);
            // height: vwM(343);
          }
        }
      }
      .table-box__item:nth-child(2) {
        padding: 15px 0 108px 0;
        @include tabletX {
          padding: vwX(15) 0 vwX(108) 0;
        }
        @include tablet {
          padding: vwM(45) 0 vwM(108) 0;
        }
        .chart img {
          width: 1105px;
          // height: 451px;
          @include tabletX {
            width: vwX(1105);
            // height: vwX(451);
          }
          @include tablet {
            // width: vwM(1540);
            // height: vwM(628);
            width: vwM(885);
            // height: vwM(361);
          }
        }
      }

      .secure-text {
        word-break: break-all;
        color: #3f3f3f;
        a {
          display: inline-block;
          color: #3f3f3f;
        }
        .highlight {
          color: #009eb5;
        }
      }
    }

    .table-box-2 {
      margin-top: vwM(-4);
      .table-box__item:nth-child(1) {
        @include tablet {
          padding-top: vwM(10);
        }
        .chart img {
          width: 1105px;
          // height: 262px;
          @include tabletX {
            width: vwX(1105);
            // height: vwX(262);
          }
          @include tablet {
            // width: vwM(1544);
            // height: vwM(366);
            width: vwM(885);
          }
        }
      }
      .table-box__item:nth-child(2) {
        margin-top: -42px;
        @include tabletX {
          margin-top: vwX(-42);
        }
        @include tablet {
          margin-top: vwM(-42);
          padding: vwM(15) 0 vwM(145) 0;
        }
        .chart img {
          width: 1105px;
          // height: 280px;
          @include tabletX {
            width: vwX(1105);
            // height: vwX(280);
          }
          @include tablet {
            // width: vwM(1548);
            // height: vwM(392);
            width: vwM(885);
          }
        }
        .secure-text {
          .highlight {
            color: #009eb5;
          }
        }
      }

      // .secure-text {
      //   color: #3f3f3f;
      // }
    }
    .awards {
      width: 1067px;
      height: 282px;
      background-image: url('../assets/images/s3_table1_awards-2.png');
      background-size: 1067px 282px;
      margin: 33px auto -30px auto;
      @include tabletX {
        width: vwX(1067);
        height: vwX(282);
        background-size: vwX(1067) vwX(282);
        margin: vwX(33) auto vwX(-30) auto;
      }
      @include tablet {
        width: vwM(830);
        height: vwM(425);
        background-image: url('../assets/images/s3_table1_awards-2_m.png');
        background-repeat: no-repeat;
        background-size: vwM(830) vwM(425);
        margin: vwM(40) auto 0 vwM(60);
      }
    }
    .awards-btn {
      margin: -110px 0 83px 367px;
      @include tabletX {
        margin: vwX(-110) 0 vwX(83) vwX(367);
      }
      @include tablet {
        margin: vwM(20) auto 0 auto;
      }
    }
    .more-btn {
      margin: 40px auto 0 auto;
      @include tabletX {
        margin: vwX(40) auto 0 auto;
      }
      @include tablet {
        margin: vwM(45) auto 0 auto;
      }
    }

    .area-bottom {
      width: 100%;
      max-width: 1920px;
      background-image: url('../assets/images/s3-2_bg_m.jpg');
      background-repeat: repeat-y;
      background-size: 1920px 761px;
      background-position: center top;
      padding-bottom: calc(220px * 0.8);
      @include tabletX {
        background-size: vwX(1920) vwX(761);
        padding-bottom: calc(vwX(220) * 0.8);
      }
      @include tablet {
        width: 100%;
        // height: vwM(1977);
        background-image: url('../assets/images/s3-2_bg_m.jpg');
        background-size: cover;
        padding-bottom: vwM(257);
      }

      .item {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        margin-top: 35px;
        @include tabletX {
          margin-top: vwX(35);
        }
        @include tablet {
          margin-top: vwM(123);
        }
      }
      .list {
        width: 267px;
        height: 165px;
        margin-right: 10px;
        @include tabletX {
          width: vwX(267);
          height: vwX(165);
          margin-right: vwX(10);
        }
        @include tablet {
          width: vwM(343);
          height: vwM(230);
        }
        &:nth-child(4),
        &:nth-child(8) {
          margin-right: 0;
          @include tablet {
            margin-right: vwM(75);
          }
        }
        &:nth-child(odd) {
          @include tablet {
            margin-right: vwM(75);
          }
        }
        &:nth-child(even) {
          @include tablet {
            margin-right: 0;
          }
        }
      }
      .list__title {
        font-size: 21px;
        font-weight: 400;
        letter-spacing: letterSpacing(120, 21px);
        @include tablet {
          font-size: vwM(30);
          letter-spacing: letterSpacing(120, vw(30));
        }

        &::after {
          display: block;
          content: '';
          width: 100%;
          height: 5px;
          background-color: #fff;
          margin: 13px 0 0 0;
          @include tablet {
            height: vwM(4);
            margin: vwM(20) 0 vwM(4) 0;
          }
        }
      }
      .list__sub-title {
        font-size: 25px;
        line-height: lineHeight(25, 40);
        letter-spacing: letterSpacing(120, 25px);
        @include tablet {
          font-size: vwM(35);
          line-height: lineHeight(35, 58);
          letter-spacing: letterSpacing(120, vw(35));
        }
      }
      .secure-text {
        color: #ffffff;
        // opacity: 0.8;
        margin-top: 6px;
        @include tablet {
          margin-top: vwM(-48);
        }
        .highlight {
          color: #ffff0f;
        }
      }
    }
    .area-bottom__content {
      width: 1105px;
      color: #fff;
      margin: 0 auto;
      padding-top: 95px;
      @include tabletX {
        width: vwX(1105);
        padding-top: vwX(95);
      }
      @include tablet {
        width: vwM(818);
        padding-top: vwM(220);
      }
    }
    .area-bottom__title {
      font-size: 42px;
      font-weight: 600;
      letter-spacing: (letterSpacing(120, 42px));
      @include tablet {
        font-size: vwM(82);
        letter-spacing: (letterSpacing(120, vwM(82)));
      }
    }
    .area-bottom__sub-title {
      font-size: 38px;
      font-weight: 500;
      line-height: lineHeight(38, 95);
      letter-spacing: (letterSpacing(114, 38px));
      margin-top: -13px;
      @include tablet {
        font-size: vwM(74);
        line-height: lineHeight(74, 95);
        letter-spacing: (letterSpacing(114, vwM(74)));
        margin-top: vwM(27);
      }
    }
  }
  .word-break {
    word-break: break-all;
    overflow-wrap: break-word;
  }
}
</style>
